import { Button, Col, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { themeConfigSelector } from "../../../modules/session/session.reducers";
import { useAppCtx } from "../../../providers/app.provider";
import posCartService from "../../../services/pos/pos-cart.services";
import { ArrowLeftIcon, CartIcon, CloseIcon } from "../../assets/icons.constants";
import DefaultLogo from "../../assets/images/coffee-mug-logo.png";
import { useSearchParams } from "../../hooks";
import ImageWithFallback from "../fnb-image-with-fallback/fnb-image-with-fallback.component";
import "./MinHeader.scss";

function MinHeader(props) {
  const posCartItems = useSelector((state) => state?.session?.posCartItems);
  const themeConfig = useSelector(themeConfigSelector);
  const history = useHistory();
  const query = useSearchParams();
  const [t] = useTranslation();
  const { NotificationDialog } = useAppCtx();

  const {
    className = "",
    addonBefore = (
      <ArrowLeftIcon
        className="arrow-left-icon cursor-pointer"
        onClick={() => {
          history.goBack();
        }}
      />
    ),
    addonBetween = (
      <ImageWithFallback
        src={themeConfig?.general?.header?.logoUrl ?? DefaultLogo}
        alt="icon"
        fallbackSrc={DefaultLogo}
        className="logo-original-theme"
      />
    ),
    addonAfter = (
      <>
        <div className="cart-in-header">
          <a href={"/pos-order?" + query.toString()}>
            {posCartItems && posCartItems?.length > 0 && (
              <div className="cart-quantity" id="cart-quantity">
                {posCartItems?.reduce((a, v) => (a = a + v?.quantity ?? 0), 0)}
              </div>
            )}
            <CartIcon className="cart-icon" />
          </a>
        </div>
        <CloseIcon className="close-icon cursor-pointer" onClick={confirmationPage} />
      </>
    ),
  } = props;

  function goToPosList() {
    NotificationDialog.hide();
  }

  function confirmationPage() {
    NotificationDialog.show({
      contentNotificationDialog: (
        <>
          <span
            dangerouslySetInnerHTML={{
              __html: t(
                "checkOutPage.titleLeaveToOrdering",
                "Do you really want to leave the ordering? You can also come back from your order detail!",
              ),
            }}
          ></span>
        </>
      ),
      onOk: goToPosList,
      onCancel: goToPosList,
      footer: (
        <>
          <Button className="ignore-leave-ordering" onClick={goToPosList}>
            {t("checkOutPage.ignore", "Ignore")}
          </Button>
          <Button onClick={closePage}>{t("checkOutPage.confirmLeave", "Confirm leave")}</Button>
        </>
      ),
    });
  }

  function closePage() {
    NotificationDialog.hide();
    const pathName = query.get("backToPath");
    if (pathName) {
      posCartService.closeQrCodePage(
        history.push({
          pathname: pathName,
        }),
      );
    } else {
      posCartService.closeQrCodePage(history.push("/"));
    }
  }

  return (
    <Row className={`min-header ${className}`}>
      <Col xs={8} className="addon-before">
        {addonBefore}
      </Col>
      <Col xs={8} className="addon-between">
        {addonBetween}
      </Col>
      <Col xs={8} className="addon-after">
        {addonAfter}
      </Col>
    </Row>
  );
}

export default React.memo(MinHeader);
